import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, inr } from "../lib/api";
import { PageShell, Loader } from "../components/SiteChrome";

export default function OrderSuccess() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    api.get(`/orders/${orderId}`).then(({ data }) => setOrder(data)).catch(() => setFailed(true));
  }, [orderId]);

  return (
    <PageShell>
      <div className="wrap" style={{ maxWidth: 620, textAlign: "center", padding: "56px 20px 80px", margin: "0 auto" }}>
        {failed ? (
          <p style={{ color: "var(--ink-dim)" }} data-testid="order-not-found">We couldn't find that order.</p>
        ) : !order ? <Loader /> : (() => {
          const paid = ["paid", "shipped", "delivered"].includes(order.status);
          return (
          <div className="fade-up" data-testid="order-success">
            <div className="success-seal" style={paid ? {} : { borderColor: "var(--hair-strong)", color: "var(--ink-dim)" }}>
              {paid ? (
                <svg viewBox="0 0 24 24" width="30" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4.5 12.5l4.8 4.8L19.5 7" />
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" width="30" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                  <circle cx="12" cy="12" r="9" /><path d="M12 7.5V12l3 2.4" />
                </svg>
              )}
            </div>
            <div className="pg-kicker">{paid ? "Order confirmed" : `Order ${order.status === "created" ? "awaiting payment" : order.status}`}</div>
            <h1 className="pg-title" style={{ margin: "12px 0 10px" }}>{paid ? "Chew incoming." : "Not paid yet."}</h1>
            <p style={{ color: "var(--ink-dim)", fontSize: 14.5, margin: "0 auto", maxWidth: 420 }}>
              {paid ? (<>Order <b style={{ color: "var(--gold-soft)" }} data-testid="order-id">{order.order_id}</b> — a confirmation
              email is on its way to {order.email}.</>) : (<>Order <b style={{ color: "var(--gold-soft)" }} data-testid="order-id">{order.order_id}</b> was
              recorded but payment didn't complete. Nothing has been charged.</>)}
            </p>
            <div className="acct-card" style={{ margin: "30px 0 24px", textAlign: "left" }}>
              {order.items.map((i) => (
                <div className="co-line" key={i.product_id}>
                  <span>{i.name} × {i.qty}</span><span>{inr(i.price * i.qty)}</span>
                </div>
              ))}
              <div className="co-tot" style={{ paddingBottom: 0 }}><span>{paid ? "Total paid" : "Total due"}</span><b data-testid="order-total">{inr(order.amount)}</b></div>
              <p style={{ color: "var(--ink-dim)", fontSize: 13, margin: "14px 0 0" }}>
                Shipping to: {order.address}, {order.city} {order.pincode}
              </p>
            </div>
            <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
              {paid
                ? <Link className="kbtn" to="/account" style={{ width: "auto" }} data-testid="order-goto-account">Track in my account</Link>
                : <Link className="kbtn" to="/checkout" style={{ width: "auto" }} data-testid="order-retry-checkout">Try payment again</Link>}
              <Link className="kbtn ghost" to="/shop" style={{ width: "auto" }} data-testid="order-goto-shop">Keep shopping</Link>
            </div>
          </div>
          );
        })()}
      </div>
    </PageShell>
  );
}
